import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import ListPage from '@/mixins/list-page'

@Component({
  components: {
    AppBreadcrumbs
  }
})
export default class CreateCase extends mixins(ListPage) {
  tiggerChose= false
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Insurance Cases'
    },
    {
      text: 'Create Cases2'
    }
  ]
  ifRelatedList = false
  showtextdialog = false
  billhtml = ''
  showtextdialog2 = false
  showtextdialog22 () {
    this.showtextdialog = false
    this.showtextdialog2 = true
    this.tiggerChose = false
    this.billhtml = 'Bill Auto 2020'
  }

  bill () {
    this.showtextdialog = true
    this.showtextdialog2 = false
    this.tiggerChose = false
    this.billhtml = 'Bill'
  }

  hide () {
    this.showtextdialog = false
    this.showtextdialog2 = false
  }

  show () {
    this.tiggerChose = true
    this.showtextdialog = false
    this.showtextdialog2 = false
  }

  canclecreatebtn () {
    this.showtextdialog2 = false
    this.showtextdialog = false
    this.tiggerChose = false
  }

  createClient () {
    this.showtextdialog = false
  }
}
